import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import { store } from "./store/storeIndex";
import { VisionContextProvider } from "./Components/ContextAPI/VisionContext";
import { CameraProvider } from "./context/CameraProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <VisionContextProvider>
      <CameraProvider>
        <App />
      </CameraProvider>
    </VisionContextProvider>
  </Provider>
  // </React.StrictMode>
);
